import { createStyles, makeStyles, PopoverOrigin } from "@material-ui/core";
import { COLORS } from "config/theme/baseTheme";

export const useStyles = makeStyles((theme) =>
  createStyles({
    card: {
      height: "auto",
      minHeight: 46 * 12, // 32rem
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      backgroundSize: "cover",
      overflow: "hidden",
      boxShadow: "none",
      borderRadius: "16px",
    },
    cardContent: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "#F6F6F6",
      "& .domain": {
        fontSize: 24,
        fontWeight: 700,
        marginTop: 16,
      },
      "& .title": {
        fontSize: 14,
        fontWeight: 600,
      },
    },
    badgeElement: {
      backgroundColor: "#EEEEEE", // Badge background color
      color: "black", // Text color
      padding: "8px 12px", // Padding for badge-like appearance
      borderRadius: 24, // Rounded corners
      display: "flex",
    },

    selectBoxContainer: {
      display: "flex",
      alignItems: "center",
      marginBottom: 16,
      borderRadius: "24px", // Rounded corners
      padding: "0 4px", // Add padding for spacing
      backgroundColor: "#0E5AA70D",
      "& .MuiFilledInput-root.Mui-focused": {
        backgroundColor: "#0E5AA70D",
      },
    },
    selectBox: {
      width: "auto",
      fontSize: "14px",
      marginLeft: 6,
      borderRadius: "24px", // Rounded corners
      color: "#1976d2", // Text color
      cursor: "default", // Remove pointer cursor to indicate no click effect
      "&:hover": {
        backgroundColor: 'unset', // Keep the same background color on hover
      },
    },

    shareIcon: { color: COLORS.PRIMARY_DARK, marginRight: 1 },
    copyLink: {
      display: "flex",
      alignItems: "center",
      marginBottom: 2,
      cursor: "pointer",
      color: COLORS.PRIMARY_DARK,
    },
    box: {
      marginBottom: 16,
      "& p": {
        fontSize: 14,
      },
    },
    qrCodeContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      position: "relative",
      width: "15rem", // Adjusted to account for padding
      height: "15rem", // Adjusted to account for padding
      border: "5px solid black", // Border around the QR code
      padding: 18, // Padding inside the border
      boxSizing: "border-box",
      borderRadius: "24px", // Rounded corners
      "& .qrCode": {
        transition: "filter 0.3s ease", // Smooth transition for blur effect
      },
    },
    overlayBox: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "rgba(0, 0, 0, 0.7)", // Black background with 70% opacity
      color: "white",
      padding: "4px 18px",
      borderRadius: "24px",
      fontWeight: "bold",
      fontSize: "12px",
      textAlign: "center",
      whiteSpace: "pre-wrap"
    },
    buttons: {
      width: "75%",
      borderRadius: 10
    },

    root: {
      padding: theme.spacing(3), // Add padding around the entire component
      overflowY: "auto", // Enable vertical scrolling if needed
      height: "100vh", // Set height to 100% of the viewport
    },
    title: {
      margin: theme.spacing(2, 0, 4, 2), // Add vertical margin
      fontWeight: 700, // Set font weight to bold
      fontSize: 28, // Set font size
      //color: COLORS.PRIMARY_DARK, // Use a primary dark color for the title
      // textAlign: 'center', // Center-align the title
    },
    container: {
      padding: theme.spacing(2), // Add padding around the grid container
      justifyContent: "space-between", // Space between items
    },
    anchor: {
      vertical: "bottom",
      horizontal: "left",
    },
    menuPropsList: {
      "& .MuiListItem-root": {
        fontSize: 12,
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        whiteSpace: "normal",
      },
      "& .MuiCheckbox-root": {
        backgroundSize: "16px 16px",
        marginRight: theme.spacing(0.75),
      },
      "& .customMenuPropsList": {
        paddingLeft: theme.spacing(5.6),
      },
    },
    menuPropsPaper: {
      maxHeight: 200,
      maxWidth: 200,
      border: `1px solid ${COLORS.BLACK_INPUT_BORDER}`,
      borderRadius: theme.spacing(1),
      overflow: "auto",
      boxShadow: "none",
    },
    noDataBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100px",
      backgroundColor: "#f5f5f5",
      borderRadius: "8px",
      marginTop: "16px",
    },
    noDataText: {
      fontSize: "16px",
      color: "#999",
      fontWeight: 500,
    },
  })
);

export const anchorOriginDefault: PopoverOrigin = {
  vertical: "bottom",
  horizontal: "left",
};
